import React, { useEffect, useState, createContext } from 'react'
import {
  Route,
  Routes,
  useLocation,
  useSearchParams,
  useNavigate
} from 'react-router-dom'
import { connect } from 'react-redux'

// pages
import Login from "./components/pages/Login"
import Progress from "./components/pages/Progress"
import Dashboard from "./components/pages/Dashboard"
import NotFound from "./components/pages/NotFound"
// layout
import Header from "./layouts/Header/Header"
import Footer from "./layouts/Footer/Footer"

// components
import CustomModal from './components/molecules/CustomModal'

// actions
import {
  logOutAction,
  loginShaAction
} from './store/sessionDuck'

import {
  gtUser,
  gtStaticContent
} from './utils/helpers'
import { getPrice, sendDataLayer } from './utils/functions'
import { doRedeem } from './utils/helpers'

import './styles/main.scss'
import Selector from './components/pages/Selector'
import TCModal from './components/molecules/TcModal'
import FaqsModal from './components/molecules/FaqsModal'
// import Toast from './components/molecules/Toast'

export const StateController = createContext(null)

function App({
  error,
  token,
  loggedIn,
  logOutAction
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [modalOpen, setMdalOpen] = useState(false)
  const [notFound, setNotFound] = useState(false)
  const [context, setContext] = useState(false)
  const [staticContent, setStaticContent] = useState(false)
  const [autologinPreloader, setAutologinPreloader] = useState(false)

  const [awardSelected, setAwardSelected] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [redemtionLoading, setRedemtionLoading] = useState(false)
  const [showErrorRedemtion, setShowErrorRedemtion] = useState(false)
  const [showSuccessRedemtion, setShowSuccessRedemtion] = useState(false)
  const [quantumName, setQuantumName] = useState('')
	const [quantumDoc, setQuantumDoc] = useState('')
  const [department, setDepartment] = useState(false)
  const [city, setCity] = useState(false)
  const [site, setSite] = useState(false)
  const [showTcModal, setShowTcModal] = useState(false)
  const [showFaqsModal, setShowFaqsModal] = useState(false)
  // const [showToast, setShowToast] = useState(false)
  // const [winnerMision1, setWinnerMision1] = useState(false)
  const [ pages, setPages] = useState([
    {page: 'selector', title: 'Selector', icon: 'icon', sublevel: false, component: <Selector privatePage />},
    {page: 'progreso', title: 'Progreso', icon: 'icon', sublevel: false, component: <Progress privatePage />},
  ])
  
  let home_page = '/selector'
  useEffect(() => {
    if(context.user && context.user.goal_amount_1 !== null) {
      setPages([
        {page: 'progreso', title: 'Progreso', icon: 'icon', sublevel: false, component: <Progress privatePage />},
      ])
    }
  }, [context])

  const pathURL = {
    "tZNsUTFTPw": "progreso",
  }

  const handleTcModal = () => {
    setShowTcModal(true)
  };

  const handleFaqsModal = () => {
    setShowFaqsModal(true)
  };
  

  const closeLoginModal = () => {
    setAutologinPreloader(false)
    setNotFound(false)
    sendDataLayer({datalayer: {event: 'invalid_credentials'} ,repeat: true})
    localStorage.removeItem('userNotFound')
    window.location.href = '/'
  }

  useEffect(() => {
    if (window.location.hash === '#terminos-y-condiciones') {
      setShowTcModal(true);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('userNotFound')) {
      setNotFound(true)

      setTimeout( () => {
        localStorage.removeItem('userNotFound')
      }, 3000 )
    } else {
      setNotFound(false)
    }
  }, [location])

  useEffect(() => {
    if (searchParams.get('utm_web')) {
      setAutologinPreloader(true)
    }

    if (!localStorage.getItem('storage')) {
      if (window.location.search !== '') {
        console.log("Navegate to:", window.location.search)
        // navigate(window.location.search)
      } else {
        const public_url = pages.find((page) => page.page === location.pathname.replace('/', '') )

        if (public_url) {
          if (!loggedIn && public_url?.component?.props?.privatePage) document.location.href = '/'

        }
      }
    }
  }, [searchParams, error])

  useEffect(() => {
    // const now = new Date();
    // const startDate = new Date('2025-06-27T00:00:00');

    // if(context.tracing && context.tracing.winner_1 === 1) {
    //   setWinnerMision1(true);
    // }
    // if(context.tracing && context.tracing.winner_1 === 1 && now >= startDate) {
    //   setShowToast(true);
    // }
    // const isToastViewed = localStorage.getItem('toastViewed')
    // if (isToastViewed) setShowToast(false)
  }, [context])

  useEffect(() => {

    if (token !== '') {
      gtUser(token).then((user) => {

        if (user?.data) {
          setContext(user.data)
          if (searchParams.get('pathurl')) {
            const path = pathURL[searchParams.get('pathurl')] || home_page
            let queryparams = ''

            for(const x of searchParams.keys()){
              if(!(x === "utm_web" || x==='pathurl')){
                queryparams += `${x}=${searchParams.get(x)}&`
              }
            }
            queryparams = queryparams.slice(0, queryparams.length - 1)
            console.log(path, queryparams)
            if (
              user?.data && 
              user?.data?.user?.goal_amount_1 === null
            ) {
              setTimeout( () => {
                window.location.href = home_page
              }, 3000 )
            }
            else {
              window.location.href = `${path}${(queryparams && queryparams !== '') && '?'}${queryparams}`
            }
          } else if (window.location.pathname !== home_page && window.location.pathname === '/') {
            if (
              user?.data && 
              user?.data?.user?.goal_amount_1 === null
            ) {
              setTimeout( () => {
                window.location.href = home_page
              }, 3000 )
            } else {
              home_page = '/progreso';
              window.location.href = home_page
            }
          }
        } else if (user.statusCode === 301 && localStorage.getItem('storage') && window.location.pathname === '/') {
          localStorage.removeItem('storage')
          window.location.reload()
        }
        if (user?.statusCode === 301 && window.location.pathname !== '/' && window.location.pathname !== '/dashboard') {
          window.location.href = '/'
        }
      }).catch(() =>  navigate('/'))

    }
  }, [token])

  useEffect(() => {

    gtStaticContent().then((content) => {
      if (content && content.content) setStaticContent(content.content)
    })
  }, [])

  const handlerModal = () => {
    if (showConfirm) {
      sendDataLayer({datalayer: {event: 'cancel_bond',product_name: awardSelected?.name ,product_price: awardSelected?.price, index: awardSelected?.index},repeat: true})
    }
    setShowConfirm(!showConfirm)

  }

  const handlerRedemtion = async () => {
    setRedemtionLoading(true)
    let validator = true
    if (awardSelected.twoStepAuth) {
      console.log("Validar aqui si la fecha es correcta")
      validator = false;
    }

    if (awardSelected.canRedem) {
      if (validator) {
        doRedeem(token, awardSelected.price, awardSelected.id, quantumName, quantumDoc, site?.selected).then((data) => {
          setRedemtionLoading(false)
          setShowConfirm(false)
  
          if (data && data.status === 200 && data.file) {
            setShowSuccessRedemtion(true)
            sendDataLayer({datalayer: { event: "redeem_bond",product_name: awardSelected?.name,product_price: awardSelected?.price,index: awardSelected?.index}, repeat: false})

  
            setTimeout( () => {
              window.location.href = pages 
                ? pages.find((page) => page.sublevel).children.find((page) => page.page.includes('redenciones')).page
                : 'mis-redenciones'
            }, 5000 )
          } else {
            sendDataLayer({datalayer: {event: 'exhausted_bond', product_name: awardSelected?.name, product_price: awardSelected?.price, index: awardSelected?.index},repeat: true})
            setShowErrorRedemtion(true)

          }
        }).catch(error => {
          console.log("ERROR ON REDENTION:", error)
        })
      } else {
        setRedemtionLoading(false)
        setShowConfirm(false)
        setShowErrorRedemtion(true)
        console.log("Validacion no completada.")
      }
    } else {
      setRedemtionLoading(false)
      setShowConfirm(false)
      setShowErrorRedemtion(true)
    }
  }

  return (
    <StateController.Provider
      value = {
        {
          setMdalOpen: setMdalOpen,
          context: context,
          staticContent: staticContent,
          pages: pages,
          awardSelected: awardSelected,
          setAwardSelected: setAwardSelected,
          handlerRootModal: handlerModal
        }
      }
    >
      {/* {loggedIn && showToast && winnerMision1 && window.location.pathname === '/progreso' &&
        <Toast
          text={`<strong>¡Todo listo para redimir tu premio!</strong> <a href="#premio">Descarga ya</a> el bono que quieres disfrutar 🤩.`}
          show={setShowToast}
          isTopBar
        />
      } */}
      <CustomModal
        title="Verifica tus datos"
        desc="La plataforma no reconoció la información que ingresaste.</br>Por favor inténtalo de nuevo."
        cta="Aceptar"
        icon={false}
        primaryAction={
          {
            action: closeLoginModal,
            buttonText: 'Cerrar',
            loading: false
          }
        }
        show={notFound} setShowModal={setNotFound}
      />

      <CustomModal
        show={showConfirm}
        setShowModal={setShowConfirm}
        redemtion={true}
        image={awardSelected.image}
        title={`COP ${getPrice(awardSelected.price)}`}
        desc={awardSelected.name}
        twoStepAuth={awardSelected.twoStepAuth}
        location={awardSelected?.location}
        brand_id={awardSelected?.brand_id}
        quantumName={quantumName}
        quantumDoc={quantumDoc}
        setQuantumName={setQuantumName}
        setQuantumDoc={setQuantumDoc}
        department={department}
        city={city}
        site={site}
        setDepartment={setDepartment}
        setCity={setCity}
        setSite={setSite}
        token={token}
        awardSelected={awardSelected}
        primaryAction={
          {
            action: handlerRedemtion,
            buttonText: "Descargar",
            loading: redemtionLoading
          }
        }
        secondaryAction={
          {
            action: handlerModal,
            buttonText: "Cancelar"
          }
        }
        terms={
          {
            termsText: "Términos y condiciones",
            termsLink: "/terminos-y-condiciones"
          }
        }
      />
      <CustomModal
        title="Error en la redención"
        desc={'Ocurrió un error al obtener tu bono. Intentalo de nuevo más tarde.'}
        cta="Aceptar"
        image="image.png"
        show={showErrorRedemtion} setShowModal={setShowErrorRedemtion}
      />
      <CustomModal
        title="Redención correcta"
        desc={`Tu bono ha sido descargado. Podrás encontrarlo en la sección <strong></strong>.`}
        cta="Aceptar"
        image="image.png"
        show={showSuccessRedemtion} setShowModal={setShowSuccessRedemtion}
      />
      {showTcModal &&
        <TCModal
          show={showTcModal}
          setShowModal={setShowTcModal}
        />
      }
      {showFaqsModal &&
        <FaqsModal
          show={showFaqsModal}
          setShowModal={setShowFaqsModal}
        />
      }

      <div className={`App ${modalOpen ? 'modalOpen' : ''} ${loggedIn ? 'loggedIn' : 'noLoggedIn'}`}>
      <Header
          headerType={1}
          logo="logo.png"
          logo_mb="logo_mb.png"
          logo_mc="logo_mc.png"
          logo_mc_mb="logo_mc_mb.png"
          items={pages}
          submenu={false}
          notifications={
            [
              {
                id: 1,
                title: "Notification",
                content: "html content",
                status: 0
              }
            ]
          }
          loggedIn={loggedIn}
          logOutAction={logOutAction}
        />

        <Routes>
          <Route path="/" element={<Login autologin={autologinPreloader} hash={searchParams.get('utm_web')} link={
            [
              {
                link: "/terminos-y-condiciones",
                text: "Términos y condiciones",
                onClick: handleTcModal
              }
            ]
          }/>} />
          {pages.map((page, i) => {
            return (
              <Route
                key={i}
                path={`/${page.page}`}
                element={page.component}
              />
            )
          })}
          <Route path="/dashboard" element={<Dashboard adminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer
          footerType={1}
          footerCardsImg="footer_cards.png"
          secondaryFooterImg="footer_cards.png"
          bankFooterImg="bank-footer.png"
          awardFooterImg="award.png"
          links={
            [
              {
                link: "/terminos-y-condiciones",
                text: "Términos y condiciones",
                onClick: handleTcModal
              },
              {
                link: "/preguntas-frecuentes",
                text: "Preguntas frecuentes",
                onClick: handleFaqsModal
              }
            ]
          }
          content="<p>Válido del 15 de mayo al 15 de julio de 2025 y solo aplica para territorio colombiano. Recuerda que por tu seguridad, el Banco de Bogotá nunca te solicitará a través de este medio información confidencial o financiera como: usuarios, claves, números de tarjetas, código de seguridad, fechas de vencimiento. Ten cuidado con esta información, recuerda que las únicas cuentas autorizadas de las que te llegará información promocional son <u>enlinea@bancodebogota.net.co</u> y <u>bdbtecomunica@contigo.bancodebogota.com.co.</u> <br/><br/>*Esta es una campaña oficial del Banco de Bogotá.<br/><br/>*Mastercard y el diseño de los círculos son marcas registradas de Mastercard International Incorporated.</p>"
          copyright="© Copyright 2024"
          logOutAction={logOutAction}
          loggedIn={loggedIn}
        />

      </div>
    </StateController.Provider>
  )
}

const mapState = ({ user: { fetching, loggedIn, token, error } }) => {
  return {
    fetching,
    loggedIn,
    token,
    error
  }
}

export default connect(mapState, { logOutAction, loginShaAction })(App)